import Axios from "../config/axios";
import { UrlConstant } from "../commom/UrlConstant";
import type { MarkReadResult, NotificationFeed } from "../types/notifications";

/** Thin wrappers over the notification endpoints. Every call resolves (never throws) so the UI cannot crash on a bad network. */

export async function fetchNotifications(opts: { limit?: number; before?: string | null; unreadOnly?: boolean } = {}): Promise<NotificationFeed | null> {
  try {
    const params: Record<string, string | number> = { limit: opts.limit ?? 20 };
    if (opts.before) params.before = opts.before;
    if (opts.unreadOnly) params.unread = "true";
    const res = await Axios.get(UrlConstant.Push.Notifications, { params });
    const d = res?.data?.data;
    if (!d || !Array.isArray(d.items)) return null;
    return { items: d.items, unread: Number(d.unread) || 0, nextBefore: d.nextBefore ?? null };
  } catch {
    return null;
  }
}

export async function fetchUnreadCount(): Promise<number | null> {
  try {
    const res = await Axios.get(UrlConstant.Push.NotificationsUnreadCount);
    const n = Number(res?.data?.data?.unread);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

/** Mark specific ids (max 100) or everything as read. */
export async function markNotificationsRead(arg: { ids: string[] } | { all: true }): Promise<MarkReadResult | null> {
  try {
    const res = await Axios.post(UrlConstant.Push.NotificationsMarkRead, arg);
    const d = res?.data?.data;
    return d ? { updated: Number(d.updated) || 0, unread: Number(d.unread) || 0 } : null;
  } catch {
    return null;
  }
}
